import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Skeleton } from "@/components/ui/skeleton";

// Lazy-loaded so the recharts bundle only ships on the dashboard home,
// not on every other route.
const DashboardSalesOverviewCard = lazy(() =>
	import("@/components/dashboard-sales-overview-card").then((m) => ({
		default: m.DashboardSalesOverviewCard,
	})),
);

export const Route = createFileRoute("/$store/_layout/")({
	component: StorePage,
});

function StorePage() {
	return (
		<div className="flex flex-1 flex-col">
			<div className="@container/main flex flex-1 flex-col">
				<div className="py-4 md:py-6">
					<div className="px-4 lg:px-6">
						<Suspense fallback={<Skeleton className="h-[420px] w-full rounded-xl" />}>
							<DashboardSalesOverviewCard />
						</Suspense>
					</div>
				</div>
			</div>
		</div>
	);
}
